// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { EmblaOptionsType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import {
  usePrevNextButtons,
  PrevButton,
  NextButton,
} from './recommendations-nav-button';
import { Product } from '../../types/product';
import { RecommendationsSettings } from '../../api/getRecomendationsSettings';
import { Config } from '../../types/config';
import { formatNumbers } from '../../utils/convert-to-arabic-price';
import { RecommendationType } from '../../api/addRecommendationView';
import { RecommendationPages } from '../../api/addRecommendationView';
import { ToastType } from '../../types/toast';
import RIYALIcon from '../../assets/riyal.svg?react';
import { getDocumentDirection } from '../../utils/get-document-direction';
import { getSessionId } from '../../utils/get-or-create-session';
import { safeTrack } from '../../utils/analytics';
import { ENTERED_FROM_RECOMMENDATIONS } from '../../constants/tracking';
import {
  setTrackingSource,
  setDirectTrackingFlag,
} from '../../utils/tracking-session';
import ProductCard from '../ProductCard';
import { getProductCardSettings } from '../../api/product-card';
import { addToCartTracking } from '../../utils/cart-tracking';
type PropType = {
  storeId: string;
  options?: EmblaOptionsType;
  products: Product[];
  settings: RecommendationsSettings;
  provider: string;
  preview: boolean;
  config?: Config;
  customer: string;
  currency: string;
  language: string;
};

const EmblaCarousel: React.FC<PropType> = (props) => {
  const {
    storeId,
    options,
    products,
    settings,
    provider,
    preview,
    config,
    customer,
    currency,
    language,
  } = props;
  const storeType = provider;
  const [emblaRef, emblaApi] = useEmblaCarousel(options);
  const [loadingStates, setLoadingStates] = useState<Record<string, boolean>>(
    {},
  );

  const [favorites, setFavorites] = useState<string[]>([]);

  const [cardSettings, setCardSettings] = useState<ProductCardSettings | null>(
    null,
  );

  const getCardSettings = async () => {
    const { uiStyles } = await getProductCardSettings(storeId, provider);
    setCardSettings({ uiStyles });
  };

  const isDarkMode = () => {
    const htmlElement = document.documentElement;
    return htmlElement.classList.contains('dark');
  };

  const getProductCardHeight = () => {
    const imageHeight = cardSettings?.uiStyles?.productCardImageHeight.replace(
      'px',
      '',
    );
    const contentHeight =
      cardSettings?.uiStyles?.productCardContentHeight.replace('px', '');
    const totalHeight = Number(imageHeight) + Number(contentHeight);
    return totalHeight.toString() + 'px';
  };

  const showToast = (message: string, type: ToastType) => {
    const event = new CustomEvent('show-toast', { detail: { message, type } });
    window.dispatchEvent(event);
  };

  const onRecommendationProductCardClick = async (product: Product) => {
    if (!preview) {
      const sessionId = getSessionId() || '';
      setTrackingSource(
        ENTERED_FROM_RECOMMENDATIONS,
        product.productId.toString(),
        {
          pageType: settings.pageType as RecommendationPages,
          recommendationType: settings.type as RecommendationType,
        },
      );

      safeTrack('product_clicked', {
        storeId: storeId,
        provider: storeType,
        customerId: customer,
        product: product.productId,
        productName: product.name.ar,
        type: 'recommendations',
        pageType: settings.pageType as RecommendationPages,
        recommendationType: settings.type as RecommendationType,
      });

      window.open(
        language === 'ar' ? product.urlTrans?.ar : product.urlTrans?.en,
        '_self',
      );
    }
  };
  const quickAddToCart = async (product: Product, quantity: number) => {
    safeTrack('product_added_to_cart', {
      storeId: storeId,
      provider: storeType,
      customerId: customer,
      product: product.productId,
      productName: product.name.ar,
      type: 'recommendations',
      pageType: settings.pageType as RecommendationPages,
      recommendationType: settings.type as RecommendationType,
    });
    setLoadingStates((prev) => ({ ...prev, [product.productId]: true }));
    setDirectTrackingFlag(); // Set flag BEFORE API call to prevent ProductView duplicate
    addToCartTracking(product.name.ar, 'recommendations', {
      pageType: settings.pageType as RecommendationPages,
      recommendationType: settings.type as RecommendationType,
    });
    await window.salla?.api.cart.quickAdd(product.productId, quantity);
    setLoadingStates((prev) => ({ ...prev, [product.productId]: false }));
  };

  const quickAddToZidCart = async (product: Product) => {
    setLoadingStates((prev) => ({ ...prev, [product.productId]: true }));
    const has_vitrin = window.vitrin == true;

    const productDetails = has_vitrin
      ? await window.zid.products.get(String(product.productId))
      : await window.zid.store.product.fetch(String(product.productId));

    const variants = has_vitrin
      ? productDetails.variants
      : productDetails.data.product.variants;

    if (variants && variants.length > 0) {
      onRecommendationProductCardClick(product);
    } else {
      setDirectTrackingFlag(); // Set flag BEFORE API call to prevent ProductView duplicate
      addToCartTracking(product.name.ar, 'recommendations', {
        pageType: settings.pageType as RecommendationPages,
        recommendationType: settings.type as RecommendationType,
      });
      const addtoCartResponse = has_vitrin
        ? await window.zid.cart.addProduct({
            product_id: product.productId,
            quantity: 1,
          })
        : await window.zid.store.cart.addProduct({
            productId: product.productId,
            quantity: 1,
          });
      setLoadingStates((prev) => ({ ...prev, [product.productId]: false }));

      if (addtoCartResponse.item || addtoCartResponse.status === 'success') {
        safeTrack('product_added_to_cart', {
          storeId: storeId,
          provider: storeType,
          customerId: customer,
          product: product.productId,
          productName: product.name.ar,
          type: 'recommendations',
          pageType: settings.pageType as RecommendationPages,
          recommendationType: settings.type as RecommendationType,
        });
        setCartBadge(addtoCartRes.data.cart.products_count);
        showToast('تمت إضافة المنتج بنجاح إلى عربة التسوق', 'success');
      } else {
        showToast('حدث خطأ أثناء إضافة المنتج إلى السلة', 'error');
      }
    }
  };

  const quickAddToWoocommerceCart = async (
    product: Product,
    quantity: number,
  ) => {
    setLoadingStates((prev) => ({ ...prev, [product.productId]: true }));
    setDirectTrackingFlag(); // Set flag BEFORE API call to prevent ProductView duplicate
    addToCartTracking(product.name.ar, 'recommendations', {
      pageType: settings.pageType as RecommendationPages,
      recommendationType: settings.type as RecommendationType,
    });
    try {
      const response = await fetch('/?wc-ajax=add_to_cart', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `product_id=${product.productId}&quantity=${quantity}`,
      });

      const data = await response.json();

      if (data.error) {
        console.error('Error adding to cart:', data.message);
      } else {
        safeTrack('product_added_to_cart', {
          storeId: storeId,
          provider: storeType,
          customerId: customer,
          product: product.productId,
          productName: product.name.ar,
          type: 'recommendations',
          pageType: settings.pageType as RecommendationPages,
          recommendationType: settings.type as RecommendationType,
        });
        console.log('Product added to cart:', data);

        // Trigger WooCommerce's `added_to_cart` event
        document.dispatchEvent(
          new CustomEvent('added_to_cart', { detail: product.productId }),
        );

        // Fetch updated cart fragments and update UI
        const cartFragmentResponse = await fetch(
          '/?wc-ajax=get_refreshed_fragments',
        );
        const cartFragmentData = await cartFragmentResponse.json();

        if (cartFragmentData && cartFragmentData.fragments) {
          for (const [selector, html] of Object.entries(
            cartFragmentData.fragments,
          )) {
            const element = document.querySelector(selector);
            if (element) {
              element.innerHTML = html; // Replace the old fragment with the new one
            }
          }
        }
      }
    } catch (error) {
      console.error('Request failed:', error);
    } finally {
      setLoadingStates((prev) => ({ ...prev, [product.productId]: false }));
    }
  };

  const quickAddToSallaFavorites = async (productId: number) => {
    await window.salla?.api.wishlist.add(productId);
  };

  const quickAddToZidFavorites = async (productId: number) => {
    const addtoFavoritesResponse = await fetch(
      `/api/v1/customer/addToWishlist`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ product_id: productId }),
      },
    );

    const addtoFavoritesRes = await addtoFavoritesResponse.json();
    return addtoFavoritesRes;
  };

  const removeFromZidFavorites = async (productId: number) => {
    const removeFromFavoritesResponse = await fetch(
      `/api/v1/customer/removeFromWishlist`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ product_id: productId }),
      },
    );

    const removeFromFavoritesRes = await removeFromFavoritesResponse.json();
    return removeFromFavoritesRes;
  };

  const fetchZidWishlist = async () => {
    await window.zid.store.customer.fetchWishlist().then((response) => {
      const products = response.data.wishlist.data;
      const productsIds = products.map((item) => item.id);
      setFavorites(productsIds);
    });
  };

  const fetchWishlist = async () => {
    if (provider === 'zid') {
      await fetchZidWishlist();
    }
  };

  const handleAddToCart = async (product: Product) => {
    if (!preview) {
      storeType === 'salla'
        ? quickAddToCart(product, 1)
        : storeType === 'zid'
        ? quickAddToZidCart(product)
        : quickAddToWoocommerceCart(product, 1);

      const sessionId = getSessionId() || '';
    }
  };

  const toggleFavorites = async (product: Product) => {
    if (provider === 'salla') {
      await quickAddToSallaFavorites(product.productId);
      const sessionId = getSessionId() || '';
      return;
    }
    if (provider === 'zid') {
      if (customer === 'undefined' || customer === undefined) {
        window.open('/auth/login', '_self');
        return;
      }
      if (favorites.includes(product.productId.toString())) {
        const res = await removeFromZidFavorites(product.productId);
        if (res.status === 'success') {
          showToast(res.data.message, 'success');
          setFavorites((prev) =>
            prev.filter((id) => id !== product.productId.toString()),
          );
        } else {
          showToast(res.data.message, 'error');
        }
      } else {
        const res = await quickAddToZidFavorites(product.productId);

        if (res.status === 'success') {
          showToast(res.data.message, 'success');
          setFavorites((prev) => [...prev, product.productId.toString()]);
          const sessionId = getSessionId() || '';
          // await addRecommendationAddToWishlist({
          //   storeId,
          //   sessionId,
          //   product,
          //   storeType,
          //   customerId:
          //     customer === undefined || customer === 'undefined'
          //       ? undefined
          //       : customer,
          //   pageType: settings.pageType as RecommendationPages,
          //   recommendationType: settings.type as RecommendationType,
          // });
        } else {
          showToast(res.data.message, 'error');
        }
      }
    }
  };

  const handleFavoriteClick = async (
    e: React.MouseEvent<HTMLDivElement>,
    product: Product,
  ) => {
    if (!preview) {
      e.stopPropagation();
      await toggleFavorites(product);
    }
  };

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  useEffect(() => {
    if (!preview) {
      void fetchWishlist();
      void getCardSettings();
    }
  }, []);

  return (
    <section className="embla" dir="rtl">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '1.5rem',
        }}
      >
        <div
          style={{
            textAlign:
              config?.recommendationsStyles?.recommendationTitleAlignment ===
              'CENTERED'
                ? 'center'
                : config?.recommendationsStyles
                    ?.recommendationTitleAlignment === 'RIGHT'
                ? 'right'
                : settings?.titlePosition?.length &&
                  settings.titlePosition === 'CENTERED'
                ? 'center'
                : 'right',
            width: '100%',
            height: '100%',
            color: isDarkMode() ? '#fff' : '#000',
          }}
        >
          <h3>
            {language === 'ar'
              ? config?.recommendationsStyles?.recommendationTitle ||
                settings?.title
              : config?.recommendationsStyles?.recommendationTitleEn ||
                settings?.titleEn ||
                settings?.title}
          </h3>
        </div>
        <div className="embla__controls">
          <div className="embla__buttons">
            <PrevButton
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
            />
            <NextButton
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
            />
          </div>
        </div>
      </div>
      <div className="embla__viewport" ref={emblaRef}>
        <div
          className="embla__container"
          style={{
            marginLeft:
              config?.recommendationsStyles?.recommendationSlideSpacing ||
              settings.uiStyles.productsSpacing,
          }}
        >
          {products.map((product) => (
            // <div
            //   key={product.id}
            //   className="embla__slide"
            //   style={{
            //     cursor: 'pointer',
            //     direction: 'rtl',
            //     borderTopRightRadius:
            //       config?.recommendationsStyles
            //         ?.recommendationProductBorderRadius ||
            //       settings.uiStyles.productBorderRadius,
            //     borderTopLeftRadius:
            //       config?.recommendationsStyles
            //         ?.recommendationProductBorderRadius ||
            //       settings.uiStyles.productBorderRadius,
            //     height:
            //       config?.recommendationsStyles?.recommendationSlideHeight ||
            //       settings.uiStyles.productHeight,
            //     flex: `0 0 ${
            //       config?.recommendationsStyles?.recommendationSlideSize ||
            //       settings.uiStyles.productWidth
            //     }`,
            //     paddingLeft:
            //       config?.recommendationsStyles?.recommendationSlideSpacing ||
            //       settings.uiStyles.productsSpacing,
            //   }}
            // >
            //   <div
            //     onClick={() => onRecommendationProductCardClick(product)}
            //     className="recommendationsImageContainer"
            //     style={{
            //       height: `calc(${
            //         config?.recommendationsStyles?.recommendationSlideHeight ||
            //         settings.uiStyles.productHeight
            //       } - 120px)`,
            //       borderTopRightRadius:
            //         config?.recommendationsStyles
            //           ?.recommendationProductBorderRadius ||
            //         settings.uiStyles.productBorderRadius,
            //       borderTopLeftRadius:
            //         config?.recommendationsStyles
            //           ?.recommendationProductBorderRadius ||
            //         settings.uiStyles.productBorderRadius,
            //     }}
            //   >
            //     <img
            //       style={{
            //         width: '100%',
            //         height: '100%', // Fill the container
            //         objectFit: 'cover', // Ensure images fill the container while maintaining aspect ratio
            //         borderTopRightRadius:
            //           config?.recommendationsStyles
            //             ?.recommendationProductBorderRadius ||
            //           settings.uiStyles.productBorderRadius,
            //         borderTopLeftRadius:
            //           config?.recommendationsStyles
            //             ?.recommendationProductBorderRadius ||
            //           settings.uiStyles.productBorderRadius,
            //       }}
            //       src={
            //         product.mainImage ||
            //         'https://cdn.shopify.com/s/files/1/0023/1342/0889/products/ClassicShirt_White_1_5cd5bf10-af18-4d0b-a477-bc3422d8401a.jpg?v=1688497040'
            //       }
            //     />
            //     {(storeType === 'salla' || storeType === 'zid') && (
            //       <div
            //         style={
            //           {
            //             position: 'absolute',
            //             top: '10px',
            //             left: '15px',
            //             '--star-color': `${
            //               config?.recommendationsStyles
            //                 ?.recommendationButtonColor ||
            //               settings.uiStyles.productAddToCartButtonColor
            //             }`,
            //           } as React.CSSProperties
            //         }
            //         onClick={(e) => handleFavoriteClick(e, product)}
            //         className={
            //           favorites.includes(product.productId)
            //             ? 'star-active'
            //             : 'star'
            //         }
            //       >
            //         <svg
            //           height="25px"
            //           width="25px"
            //           version="1.1"
            //           id="Layer_1"
            //           xmlns="http://www.w3.org/2000/svg"
            //           viewBox="0 0 495 495"
            //         >
            //           <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            //           <g
            //             id="SVGRepo_tracerCarrier"
            //             stroke-linecap="round"
            //             stroke-linejoin="round"
            //           ></g>
            //           <g id="SVGRepo_iconCarrier">
            //             <g>
            //               <path d="M362.96,14.24c-49.72,0-92.95,27.53-115.46,68.13v398.39C284.67,452.84,495,288.55,495,146.28 C495,73.36,435.88,14.24,362.96,14.24z"></path>
            //               <path d="M132.04,14.24C59.12,14.24,0,73.36,0,146.28c0,142.26,210.33,306.55,247.5,334.48V82.37 C224.99,41.77,181.76,14.24,132.04,14.24z"></path>
            //             </g>
            //           </g>
            //         </svg>
            //       </div>
            //     )}
            //   </div>

            //   <div
            //     style={{
            //       backgroundColor: 'white',
            //       paddingTop: '10px',
            //       paddingBottom: '10px',
            //       paddingInline: '10px',
            //       borderBottomRightRadius: '.75rem',
            //       borderBottomLeftRadius: '.75rem',
            //     }}
            //   >
            //     <div
            //       className="single-line"
            //       style={{ fontWeight: 700, textAlign: 'start' }}
            //       title={product.name.ar}
            //       onClick={() => onRecommendationProductCardClick(product)}
            //     >
            //       {product.name.ar}
            //     </div>
            //     {product.discountedPrice ? (
            //       <div
            //         style={{
            //           display: 'flex',
            //           alignItems: 'start',
            //           fontSize: '14px',
            //         }}
            //       >
            //         <div
            //           style={{
            //             color:
            //               config?.recommendationsStyles
            //                 ?.recommendationPriceColor ||
            //               settings?.uiStyles?.productPriceTextColor,
            //             marginInlineEnd: '6px',
            //             display: 'flex',
            //             alignItems: 'center',
            //           }}
            //         >
            //           {formatNumbers(
            //             product.discountedPrice,
            //             config?.recommendationsStyles?.enableEnglishPrices ||
            //               settings?.uiStyles?.enableEnglishPrices
            //               ? 'en-US'
            //               : 'ar-SA',
            //             currency,
            //           )}
            //           {currency === 'SAR' && (
            //             <RIYALIcon
            //               fill={
            //                 config?.recommendationsStyles
            //                   ?.recommendationPriceColor ||
            //                 settings?.uiStyles?.productPriceTextColor
            //               }
            //               style={{ marginInlineStart: '3px' }}
            //             />
            //           )}
            //         </div>
            //         <div
            //           style={{
            //             color: '#AD1A10',
            //             textDecoration: 'line-through',
            //             display: 'flex',
            //             alignItems: 'center',
            //           }}
            //         >
            //           {formatNumbers(
            //             product.price,
            //             config?.recommendationsStyles?.enableEnglishPrices ||
            //               settings?.uiStyles?.enableEnglishPrices
            //               ? 'en-US'
            //               : 'ar-SA',
            //             currency,
            //           )}
            //           {currency === 'SAR' && <RIYALIcon fill="#AD1A10" />}
            //         </div>
            //       </div>
            //     ) : (
            //       <div
            //         style={{
            //           display: 'flex',
            //           alignItems: 'start',
            //           justifyContent: 'start',
            //           fontSize: '14px',
            //         }}
            //       >
            //         <div
            //           style={{
            //             color:
            //               config?.recommendationsStyles
            //                 ?.recommendationPriceColor ||
            //               settings.uiStyles.productPriceTextColor,
            //             display: 'flex',
            //             alignItems: 'center',
            //           }}
            //         >
            //           {formatNumbers(
            //             product.price,
            //             config?.recommendationsStyles?.enableEnglishPrices ||
            //               settings?.uiStyles?.enableEnglishPrices
            //               ? 'en-US'
            //               : 'ar-SA',
            //             currency,
            //           )}
            //           {currency === 'SAR' && (
            //             <RIYALIcon
            //               fill={
            //                 config?.recommendationsStyles
            //                   ?.recommendationPriceColor ||
            //                 settings?.uiStyles?.productPriceTextColor
            //               }
            //             />
            //           )}
            //         </div>
            //       </div>
            //     )}
            //     <div
            //       style={{
            //         display: 'flex',
            //         justifyContent: 'center',
            //         alignItems: 'center',
            //       }}
            //     >
            //       <button
            //         style={{
            //           marginTop: 3,
            //           border:
            //             config?.recommendationsStyles
            //               ?.recommendationButtonType === 'filled'
            //               ? `1px solid ${config?.recommendationsStyles.recommendationButtonColor}`
            //               : config?.recommendationsStyles
            //                   ?.recommendationButtonType === 'contained'
            //               ? 'none'
            //               : settings.uiStyles.productAddToCartButtonType ===
            //                 'filled'
            //               ? `1px solid ${settings?.uiStyles?.productAddToCartButtonColor}`
            //               : 'none',
            //           backgroundColor:
            //             config?.recommendationsStyles
            //               ?.recommendationButtonType === 'contained'
            //               ? config.recommendationsStyles
            //                   .recommendationButtonColor
            //               : config?.recommendationsStyles
            //                   ?.recommendationButtonType === 'filled'
            //               ? 'transparent'
            //               : settings.uiStyles.productAddToCartButtonType ===
            //                 'contained'
            //               ? settings?.uiStyles?.productAddToCartButtonColor
            //               : 'transparent',
            //           color:
            //             config?.recommendationsStyles
            //               ?.recommendationButtonTextColor ||
            //             settings.uiStyles.productAddToCartButtonTextColor,
            //           borderRadius:
            //             config?.recommendationsStyles
            //               ?.recommendationButtonBorderRadius ||
            //             settings.uiStyles.productAddToCartButtonBorderRadius,
            //         }}
            //         className="cartButton"
            //         onClick={() => {
            //           handleAddToCart(product);
            //         }}
            //         disabled={loadingStates[product.id]}
            //       >
            //         {loadingStates[product.productId] ? (
            //           <div
            //             style={{
            //               position: 'relative',
            //             }}
            //           >
            //             <span
            //               className="loader-alfinder-add-to-cart"
            //               style={{
            //                 border: `3px solid ${
            //                   config?.recommendationsStyles
            //                     ?.recommendationButtonColor ||
            //                   settings.uiStyles.productAddToCartButtonColor
            //                 }`,
            //                 borderBottomColor: 'transparent',
            //                 borderRadius: '50%',
            //               }}
            //             ></span>
            //           </div>
            //         ) : (
            //           <>
            //             {config?.recommendationsStyles
            //               ?.recommendationButtonText ||
            //               settings.uiStyles.productAddToCartButtonText}
            //           </>
            //         )}
            //       </button>
            //     </div>
            //   </div>
            // </div>
            // <div
            //   key={product.id}
            //   className="embla__slide"
            //   style={{
            //     cursor: 'pointer',
            //     direction: 'rtl',
            //     borderTopRightRadius:
            //       cardSettings?.uiStyles?.productCardBorderRadius,
            //     borderTopLeftRadius:
            //       cardSettings?.uiStyles?.productCardBorderRadius,
            //     height: getProductCardHeight(),
            //     // flex: `0 0 ${cardSettings?.uiStyles?.productCardWidth}`,
            //     paddingLeft: '1rem',
            //   }}
            // >
            <ProductCard
              product={product}
              config={cardSettings?.uiStyles}
              handleProductClick={onRecommendationProductCardClick}
              toggleFavorites={toggleFavorites}
              handleAddToCart={handleAddToCart}
              loadingStates={loadingStates}
              preview={false}
              currency={currency}
              type="recommendation"
              language={language}
            />
            // </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EmblaCarousel;
